import { gql } from '@apollo/client';

export const GET_SUBSIDY_REPORT_FILTER_VALUES = gql`
  query GetSubsidyReportFilterValues {
    subsidyReportFilterValues {
      lenders {
        lenderId
        lenderName
      }
      dealers {
        dealerId
        dealerName
      }
      equipments {
        equipmentId
        equipmentName
      }
    }
  }
`;
